<div class="reusable-calendar-container">
  <div class="calendar-header" *ngIf="showNavigation">
    <h6 class="calendar-title">{{ getCalendarTitle() }}</h6>
  </div>
  
  <mat-calendar
    [selected]="selectedDate"
    [dateClass]="dateClassFunction"
    (selectedChange)="onDateSelected($event)"
    (monthSelected)="onMonthChanged($event)"
    class="custom-calendar">
  </mat-calendar>
</div>
